module.exports = __webpack_public_path__ + "static/media/code.6eebb32d.svg";